export default {
  responderExigencia: state => state.redeSIM.responderExigencia
};
